export enum Environments {
    Development = "dev",
    Test = "test",
    Prod = "",
}
